import { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { Stack, Text } from '@mantine/core';

import { UiCard } from '../../components/ui/ui-card/ui-card';

type RedirectToBankProps = {
  url: string;
};

export const RedirectToBank = ({ url }: RedirectToBankProps) => {
  useEffect(() => window.location.assign(url), [url]);

  return (
    <Stack spacing="sm">
      <UiCard>
        <Text>
          <Trans>
            Выполняется переход на сайт банка для оплаты. Если этого не
            произошли, нажмите на ссылку
          </Trans>
          :{' '}
          <a href={url}>
            <Trans> Перейти к оплате</Trans>
          </a>
        </Text>
      </UiCard>
    </Stack>
  );
};
